<template>
  <div class="mb-3 mt-3">
    <b-container>
      <b-row>
        <b-col v-if="!loaded && !showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('colony.form.not_found') }}</p>
          </b-card>
        </b-col>
      </b-row>
      <h1 v-if="loaded && !showError" class="text-primary font-weight-bold text-center mb-5">{{ data.title || "\u00a0" }}</h1>
      <b-row class="mb-3"  v-if="loaded && !showError">
        <b-col class="col-12">
          <b-form-select :class="{ 'with-placeholder': !form.target }" v-model="form.target" required :state="$v.form.target.$dirty ? !$v.form.target.$error : null" @blur="$v.form.target.$touch">
            <option :value="null" disabled>{{ $t('unite_colonies.target.label') }}</option>
            <option v-for="(colony, i) in allColonies" :value="colony" :key="i">{{ colony.title }}</option>
          </b-form-select>
        </b-col>
      </b-row>
<!--      <b-row class="mb-3"  v-if="loaded && form.useQueen">-->
<!--        <b-col class="col-12">-->
<!--          <b-form-group label-for="useTargetQueen">-->
<!--            <b-form-checkbox id="useTargetQueen" v-model="form.useQueen">{{ $t('unite_colonies.useQueen') }}</b-form-checkbox>-->
<!--          </b-form-group>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row class="mb-3"  v-if="loaded && hasQueen">
        <b-col class="col-12 col-md-12 mb-3">
          <b-alert show variant="warning" class="text-center">{{ $t('unite_colonies.useQueen') }}</b-alert>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col class="col-12 mb-3">
          <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent text-primary border-primary border form-control text-center" :title="$t('unite_colonies.cancel')" :to="'/colony/' + colony + '/' + data.apiary">
            {{ $t('unite_colonies.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6">
          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies.submit')" @click.prevent="submit">
            {{ $t('unite_colonies.submit') }}
          </b-link>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModalColonyUnite'" centered hide-header-close @ok="hideModal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'UniteColonies',
  props: ['colony'],
  data () {
    return {
      showError: false,
      loaded: false,
      loading: false,
      hasQueen: false,
      useQueen: false,
      data: {
        title: null
      },
      allColonies: [],
      form: {
        target: null
      }
    }
  },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineModalColonyUnite')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalColonyUnite')
    },
    async submit () {
      if (navigator.onLine) {
        this.$v.form.$touch()
        if (!this.$v.$error) {
          // console.log(this.form.target.queen)
          // console.log(this.hasQueen)
          if (this.form.target.queen === undefined && this.hasQueen) {
            this.useQueen = true
          }
          this.loading = true
          let result
          try {
            const token = await this.$api.user.getToken()
            result = await this.$api.colonies.unite({ from: this.colony, to: this.form.target.id, useQueen: this.useQueen, token })
            this.loading = false
          } catch (e) { // network error etc.
            if (e.response && e.response.status === 403) {
              this.loading = false
              this.$router.replace('/login')
            }

            result = false
          }
          if (result) {
            this.$router.replace('/apiary/' + this.data.apiary)
          }
          return result
        }
      } else {
        this.showOffLineModal()
      }
    }
  },
  validations: {
    form: {
      target: {
        required
      }
    }
  },
  async mounted () {
    if (this.colony) {
      const vm = this
      try {
        this.data = await this.$api.colonies.getOne(this.colony)
        let queen
        if (this.data.queen) {
          queen = await this.$api.queens.getOne(this.data.queen)
          // console.log(queen)
          if (queen) {
            this.hasQueen = true
          }
        }

        this.allColonies = (await this.$api.colonies.getAll()).filter(function (row) {
          return row.apiary &&
            row.id !== vm.colony &&
            (
              !row.field_massnahmen_und_aktionen ||
              Object.values(row.field_massnahmen_und_aktionen).filter(function (action) {
                return action.type === 'aktion_aufloesung' || action.type === 'aktion_vereinigung'
              }).length === 0
            )
        })
        // console.log(this.allColonies)

        if (this.data) {
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style scoped>
  .container {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
